import { UTM_FIELD_BY_PARAM } from "~/feature/attribution/constants";
import type {
  IFirstTouch,
  IFirstTouchSource,
} from "~/feature/attribution/type";

const SOURCE_FIELDS: (keyof IFirstTouchSource)[] = [
  ...Object.values(UTM_FIELD_BY_PARAM),
  "referrerDomain",
];

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const isTimestamp = (value: unknown): value is string =>
  typeof value === "string" && !Number.isNaN(Date.parse(value));

const parseJson = (raw: string): unknown => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const pickSource = (record: Record<string, unknown>): IFirstTouchSource =>
  SOURCE_FIELDS.reduce<IFirstTouchSource>((source, field) => {
    const value = record[field];

    return typeof value === "string" ? { ...source, [field]: value } : source;
  }, {});

export const parseFirstTouch = (raw: string | null): IFirstTouch | null => {
  if (raw === null) {
    return null;
  }

  const record = parseJson(raw);

  if (!isRecord(record) || !isTimestamp(record.firstVisitAt)) {
    return null;
  }

  return { ...pickSource(record), firstVisitAt: record.firstVisitAt };
};
